import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

const PREFIX = 'dataGridTitle';

const classes = {
  container: `${PREFIX}-container`,
  title: `${PREFIX}-title`,
};

const StyledTitleDiv = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    Width: '100%',
    minHeight: '48px',
    height: '100%',
    display: 'flex',
    alignItem: 'center',
    gap: '24px',
  },
  [`& .${classes.title}`]: {
    fontFamily: 'Bitter',
    fontSize: '30px',
    fontWeight: 700,
    lineHeight: '40px',
    letterSpacing: '0.25px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
    color: 'rgba(1, 16, 18, 0.90)',
  },
}));

type DataGridTitleProps = {
  children: React.ReactNode;
};

const DataGridTitle = ({ children }: DataGridTitleProps) => {
  return (
    <StyledTitleDiv className={classes.container}>
      <Typography className={classes.title}>{children}</Typography>
    </StyledTitleDiv>
  );
};

export { DataGridTitle };
export type { DataGridTitleProps };
